import React from 'react';
import { useWindowSize } from 'usehooks-ts';
import cx from 'classnames';
import '@assets/page/ScrollTop.scss';

const NoSSR = ({ children }) => {
  return (
    <React.Fragment>
      {navigator.userAgent !== 'ReactSnap' && <>{children}</>}
    </React.Fragment>
  );
};

export default NoSSR;
